import React from 'react';
import { Flex, Text, VStack } from '@chakra-ui/react';
import { FiAlertTriangle } from 'react-icons/fi';
import { Collab } from '@foodfluence/shared';
import { getRemainingReschedules } from '../utils/rescheduleUtils';
import { SheetButton, SheetFooter } from '../../components/counter-flow/sheetParts';
import WizardSheet from './WizardSheet';

interface RescheduleCollabWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  collab?: Collab;
}

const RescheduleCollabWarningModal: React.FC<RescheduleCollabWarningModalProps> = ({
  isOpen,
  onClose,
  onContinue,
  collab,
}) => {
  const remainingReschedules = collab ? getRemainingReschedules(collab) : 0;
  const isLastReschedule = remainingReschedules === 1;
  return (
    <WizardSheet isOpen={isOpen} onClose={onClose} title="Rescheduling may impact future opportunities">
      <VStack spacing="12px" align="stretch" fontSize="15px" lineHeight="1.45" color="#3E3E42">
        {isLastReschedule && (
          <Flex p="12px 14px" borderRadius="14px" bg="#FFF1D6" color="#5C3900" gap="10px" fontSize="14px" lineHeight="1.4">
            <Flex as="span" flex="none" mt="1px" aria-hidden><FiAlertTriangle size={20} strokeWidth={2.2} /></Flex>
            <Text as="span" fontWeight={600}>Final reschedule - no more changes after this</Text>
          </Flex>
        )}
        <Text m={0}>
          By rescheduling, your Creator Score may be affected — especially if it's close to the scheduled date. Your score helps determine how often you're selected for paid opportunities.
        </Text>
        <Text m={0}>
          Brands often coordinate logistics and content plans around your original schedule. Frequent reschedules can reduce trust and may limit future campaign invites.
        </Text>
        <Text m={0} fontWeight={600} color="#0E0E0E">
          Please only reschedule if absolutely necessary.
        </Text>
      </VStack>
      <SheetFooter>
        <SheetButton tone="outline" onClick={onContinue}>Reschedule Anyway</SheetButton>
        <SheetButton onClick={onClose}>Keep Schedule</SheetButton>
      </SheetFooter>
    </WizardSheet>
  );
};

export default RescheduleCollabWarningModal;
